var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),(!_vm.isVisitorChatPage)?_c('ChatWidget',{attrs:{"channelCode":_vm.currentChannelCode}}):_vm._e(),_c('Toast'),_c('ConfirmDialog')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }